function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSalesIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "albwrdzfxa"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 4504",
    style: {
      fill: "#17ae7b"
    },
    d: "M0 0h42v42H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "mbgb9c1z2b"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 4505",
    style: {
      fill: "#17ae7b"
    },
    d: "M0 0h44.8v44.8H0z"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 23723"
  }, /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 4558",
    width: 50,
    height: 50,
    rx: 4,
    style: {
      fill: "rgba(23,174,123,.1)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 23655"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "All transactions-icon"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Mask Group 17880",
    style: {
      clipPath: "url(#albwrdzfxa)"
    },
    transform: "translate(4 4)"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Mask Group 17879",
    transform: "translate(-1.4 -1.4)",
    style: {
      clipPath: "url(#mbgb9c1z2b)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "monitoring_FILL0_wght400_GRAD0_opsz48 (1)",
    d: "M6 37.88v-3.366l2.657-2.657v6.023zm7.306 0V27.43l2.657-2.657V37.88zm7.306 0V24.773l2.657 2.7V37.88zm7.306 0V27.474l2.657-2.657V37.88zm7.306 0V20.346l2.657-2.657V37.88zM6 27.43v-3.763l12.4-12.309 7.084 7.084L37.88 6v3.764l-12.4 12.442-7.08-7.085z",
    transform: "translate(.361 .754)",
    style: {
      fill: "#17ae7b"
    }
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSalesIcon);
export default __webpack_public_path__ + "static/media/sales-icon.77d8892045bdbef59d01f401fcb36b80.svg";
export { ForwardRef as ReactComponent };